import { useState } from 'react'
import { postFile } from '@/controllers/postFile'
import { showToast } from '@/utils/toast'

const formatFile = (image) => {
  if (!image) return
  let splitImage = image.split('.')
  return splitImage[splitImage.length - 1]
}

const SIZELIMIT = 52428800

export const useUploadFile = () => {
  const [loadingFile, setLoadingFile] = useState(false)

  const uploadFile = async (event, attached, setAttached) => {
    if (event?.target?.files[0]?.size > SIZELIMIT) {
      showToast('El archivo seleccionado es demasiado grande', 'error')
      return
    }

    setLoadingFile(true)
    const formData = new FormData()
    formData.append('file', event?.target?.files[0], event?.target?.files[0]?.name)
    let fileUpload = await postFile(formData)
    fileUpload = fileUpload?.split(' ')?.join('%20')

    let auxData = {
      format: formatFile(fileUpload),
      name: event.target.files[0].name,
      url: fileUpload,
    }

    setAttached([...attached, auxData])
    setLoadingFile(false)
  }

  return {
    loadingFile,
    uploadFile,
  }
}
